import React from 'react';
import {Redirect, withAuthentication} from '../../js/components/Routes';
import {useAppContext} from '../../js/hooks';

const UserPage = withAuthentication(() => {
  const {currentUser} = useAppContext();
  let url = `/users/${currentUser.uuid}/settings`;
  url = window.location.hash ? `${url}${window.location.hash}` : url;
  return <Redirect to={url} />;
});

export default UserPage;
